import cacheSystem from '@utils/cacheSystem';
import { LocationService } from '@services';

const INSTANCE_ERROR = { message : 'Unable to initialize the cacheSystem' };

export default class CachedLocationService {
	static getAllMinimalData(...params) {
		const instance = cacheSystem.getInstance();

		if (!instance) return Promise.reject(INSTANCE_ERROR);

		return instance.getOrUpdate(
			`location.getAllMinimalData${JSON.stringify(params)}`,
			LocationService.getAll.bind(null, ...params),
			{
				returnItemValue : true,
			},
		);
	}
}
